// extracted by mini-css-extract-plugin
module.exports = {"container":"Wopxv","date":"_2fPSH"};